// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"opera"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M7.99805 6C14.7 6 16.4112 11.2777 16.8482 15.0002C18.5739 12.657 21.9974 12.001 21.9974 12.001L20.9974 18.001L2.99805 17.9998L1.99805 14.001C3.4261 14.001 4.69219 14.3026 6.04639 14.675L4.99805 11.0117C7.49459 11.0117 9.9242 11.9555 9.93091 11.9582C9.93111 11.959 9.931 11.9609 9.93198 11.9607C9.48405 10.1377 8.86001 8.06872 7.99805 6Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M6.99805 18.0004L6.04445 14.6745C6.04445 14.6745 4.49805 14.001 1.99805 14.001L2.99805 17.9998L6.99805 18.0004ZM6.99805 18.0004L10.998 18.0017M6.99805 18.0004L4.99805 11.0117C7.49805 11.0117 9.93092 11.9582 9.93092 11.9582C10.7832 15.4279 10.998 18.0017 10.998 18.0017M10.998 18.0017L16.998 17.9998C16.998 17.9998 16.998 16.2771 16.8483 15.001C16.4115 11.2784 14.7004 6 7.99805 6C10.498 12 10.998 18.0017 10.998 18.0017ZM20.9974 18.001L21.9974 12.001C21.9974 12.001 18.5731 12.6572 16.8477 15.001C16.9974 16.2771 16.9974 17.9998 16.9974 17.9998L20.9974 18.001Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-opera')
export default class OperaIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'opera',
    }
  }
}
